/** Filters the check-in list by guest name. */
export function CheckInSearchInput({
  value,
  onChange,
}: {
  value: string;
  onChange: (v: string) => void;
}) {
  return (
    <input
      value={value}
      placeholder="Search guest name…"
      onChange={(e) => onChange(e.target.value)}
      aria-label="Search guest name"
      style={{
        height: 38,
        padding: '0 12px',
        fontSize: 14,
        border: '1px solid var(--nb-border-2)',
        borderRadius: 10,
        background: 'var(--nb-bg)',
        color: 'var(--nb-ink)',
      }}
    />
  );
}
